export default __webpack_public_path__ + "static/media/dynamodb.27be16ee.jpg";